import React from "react";

import AutoComplete from "../autoCompleteCommon";

interface Props {
  value: any;
  onChange: any;
  data: Array<any>;
  label?: string;
  isError?: boolean;
  helperText?: string;
  placeholder?: string;
  disabled?: boolean;
  isMultiple?: boolean;
  marginRightProps?: number;
  width?: string;
  borderRadius?: string | undefined;
}

const SelectAutoComplete: React.FC<Props> = ({
  data,
  onChange,
  value,
  label,
  isError,
  helperText,
  placeholder,
  isMultiple,
  marginRightProps,
  disabled,
  borderRadius,
  width,
}) => (
  <AutoComplete
    borderRadius={borderRadius || "8px"}
    value={value || ""}
    label={label || ""}
    data={data}
    width={width}
    marginRightProps={marginRightProps}
    isMultitple={isMultiple}
    onChange={onChange}
    isError={isError}
    placeholder={placeholder}
    helperText={helperText}
    disabled={disabled}
  />
);
export default SelectAutoComplete;
